import { IconProps } from '.';

const CircleIcon = ({ color, customClasses }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 376 376"
      fill="none"
      className={customClasses}
    >
      <circle
        cx="188"
        cy="188"
        r="95"
        stroke={color || 'var(--color-ui-knockout-primary)'}
      />
    </svg>
  );
};

export default CircleIcon;
